import React, {useState} from "react";
import {generateFileMediaUrl} from "../../utils/generateMemberMediaUrl";
import { defaultEmptyLogo } from "../../assets/images";

export function Image(props) {
    const {path, className = '', alt = ''} = props;
    const [brokenImage, setBrokenImage] = useState(false);

    const imageUrl = brokenImage ? defaultEmptyLogo : generateFileMediaUrl(path);
    brokenImage &&  console.log(imageUrl);
    return <img src={imageUrl}
                className={className}
                alt={alt}
                onError={() => {
                    // console.log('broken')
                    setBrokenImage(true)
                }}/>
}
